import React from 'react';
import Autosuggest from 'react-autosuggest';
import Form from 'react-bootstrap/Form';
import ServiceCalls from '../utils/serviceCalls.js';
import CommonUtils from '../utils/siteUtils.js';
import RoleUtils from '../utils/roleUtils.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import '../styles/Avatar.css';

class PayeeSelection extends React.Component {

    constructor(props) {
        super(props);
        this.handlePayeeChange = this.handlePayeeChange.bind(this);
        //US6942575    
        this.getSuggestions = this.getSuggestions.bind(this);
        //US6942575  
        this.renderSuggestion = this.renderSuggestion.bind(this);
        //Set default selection
        this.state = {
            supplierSuggestionValue: null,
            suggestions: [],
            currentPayee: undefined,
            showAllSuppliers: false, // tracks dropdown
            dropdownOpen: false, //tracks dropdown
        };
        this.dropdownRef = React.createRef(); // detecting clicks outside the dropdown
        this.handleOutsideClick = this.handleOutsideClick.bind(this);
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleOutsideClick);
        const { currentUser } = this.props;
        var curSupId = (currentUser) ? Number(currentUser.suppliers[0].supplierId) : undefined;
        var sessionSupId = (sessionStorage.getItem("curSupName")) ? Number(sessionStorage.getItem("curSupName")) : curSupId;
        this.setPayeeSelection(sessionSupId);
        //Build Suggestions array
        var vendorSetIdArr = [];
        if (currentUser.suppliers && currentUser.suppliers.length > 5) {
            vendorSetIdArr = CommonUtils.buildPayeeSelections(currentUser.suppliers);
        }
        else {
            vendorSetIdArr = currentUser.suppliers;
        }

        this.setState({
            currentPayee: sessionSupId,
            suggestions: vendorSetIdArr,
        });
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleOutsideClick);
    }

    // Closes the dropdown when a click is detected outside the dropdown 
    handleOutsideClick(e) {
        if (this.dropdownRef.current && !this.dropdownRef.current.contains(e.target)) {
            this.setState({ dropdownOpen: false });
        }
    }

    componentDidUpdate(oldProps, oldState) {
        if (oldState.currentPayee !== this.state.currentPayee) {
            this.setState({
                currentPayee: this.state.currentPayee
            });
        }
    }

    setPayeeSelection(companyId) {
        ServiceCalls.setCurrentSupplier(companyId).then(function (data) {
        });
    }

    handlePayeeChange(event, suggestionObj) {
        var payeeId = null;
        var payeeName = null;

        if (suggestionObj) {
            payeeId = suggestionObj.suggestion.supplierId;
            payeeName = this.renderSupplierSuggestion(suggestionObj.suggestion);
        }
        else {
            payeeId = Number(event.target.value);
        }
        this.setPayeeSelection(payeeId);
        //Save in session
        sessionStorage.setItem("curSupName", payeeId);
        this.setState({
            supplierSuggestionValue: payeeName,
            currentPayee: payeeId
        });
        this.props.onCompanyChange(payeeId);
    }

    renderSupplierSuggestion(supplierData) {
        return (`${supplierData.supplierName} (${supplierData.vendorId})`);
    }
    escapeRegexCharacters(str) {
        return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }

    getSuggestions = value => {
        const { currentUser } = this.props;

        //US6942575 
        const escapedValue = this.escapeRegexCharacters(value.trim());

        if (escapedValue === '') {
            return [];
        }
        const regex = new RegExp('^' + escapedValue, 'i');

        //Sort list
        var sList = [];
        sList = currentUser.suppliers.filter(sup =>
            regex.test(sup.supplierName) || regex.test(sup.vendorId));

        return CommonUtils.buildPayeeSelections(sList);
    };

    onSuggestionsFetchRequested = ({ value }) => {
        this.setState({
            suggestions: this.getSuggestions(value)
        });
    };
    onSuggestionsClearRequested = () => {
        this.setState({
            suggestions: []
        });
    };
    onChange = (event, { newValue, method }) => {
        if (method === 'type') {
            this.setState({
                supplierSuggestionValue: newValue
            });
        }
    };
    onFocus = (event) => {
        this.setState({
            supplierSuggestionValue: ''
        });
    };
    offFocus = (event) => {
        const { currentUser } = this.props;
        var currentSupplier = currentUser.suppliers.filter(s => {
            return s.supplierId === this.state.currentPayee
        });
        var supplierDisplay = this.renderSupplierSuggestion(currentSupplier[0]);
        if (currentSupplier.length > 0) {
            //var suggestionValue = `${currentSupplier[0].supplierName} (${currentSupplier[0].vendorId})`;// supplierSuggestionValue: currentSupplier[0].supplierName
            this.setState({
                supplierSuggestionValue: supplierDisplay
            });
        }
    };
    renderSuggestion(suggestion) {
        //Show Name and VendorID

        return (<div className="suggestionItemUHG">
            <span className="supSugName">{suggestion.supplierName}</span>
            <span className="supSugId">{suggestion.vendorId}</span>
        </div>);
    }
    renderSectionTitle(section) {
        //DEBUG console.log(`Rendering Section Title for ${JSON.stringify(section)} and a name of ${section.vendorSetId}`);
        return (
            <div className="sectHdr"><strong>{section.vendorSetId}</strong></div>
        );
    }

    getSectionSuggestions(section) {

        return section.suppliers;
    }

    shouldRenderSuggestions(value, reason) {
        return (value); //.trim().length > 2;
    }

    getSuggestionValue(suggestion) {
        return suggestion.text;
    }
    getPayeeDisplay() {
        const { currentPayee, supplierSuggestionValue, suggestions, showAllSuppliers } = this.state;
        const { currentUser } = this.props;
        const MAX_SUPPLIERS = 15;
        //US10592361 Optum Admins (AP_Admin, Site_Admin) retain the existing Autosuggest typeahead; all others get the custom dropdown
        const isOptumAdmin = RoleUtils.canAccess(currentUser, currentPayee, RoleUtils.optumAdminPerms());

        if (currentUser && currentPayee) {
            var currentSupplier = currentUser.suppliers.filter(s => {
                return s.supplierId === currentPayee
            });

            if (currentUser.suppliers.length > 5 && isOptumAdmin) {
                var value = (supplierSuggestionValue !== null) ? supplierSuggestionValue : this.renderSupplierSuggestion(currentSupplier[0]);
                const inputProps = {
                    placeholder: 'Type in supplier name',
                    value,
                    onChange: this.onChange,
                    onFocus: this.onFocus,
                    onBlur: this.offFocus
                };
                return (
                    <Autosuggest
                        multiSection={true}
                        suggestions={suggestions}
                        shouldRenderSuggestions={this.shouldRenderSuggestions}
                        onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                        onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                        onSuggestionSelected={this.handlePayeeChange}
                        getSuggestionValue={this.getSuggestionValue}
                        renderSectionTitle={this.renderSectionTitle}
                        getSectionSuggestions={this.getSectionSuggestions}
                        renderSuggestion={this.renderSuggestion}
                        inputProps={inputProps}
                    />);
            }
            else if (currentUser.suppliers.length > 1) {
                const sortedSuppliers = [...currentUser.suppliers].sort(CommonUtils.compareSuppliersBySupplierName);
                const showToggle = !isOptumAdmin && currentUser.suppliers.length > MAX_SUPPLIERS;
                const suppliersToShow = (showToggle && !showAllSuppliers)
                    ? sortedSuppliers.slice(0, MAX_SUPPLIERS)
                    : sortedSuppliers;
                const { dropdownOpen } = this.state;
                const selectedSupplier = sortedSuppliers.find(s => s.supplierId === currentPayee);
                const selectedLabel = selectedSupplier ? this.renderSupplierSuggestion(selectedSupplier) : 'Select Payee';
                return (
                    <div className="payeeCustomDropdown" ref={this.dropdownRef}>
                        <input
                            type="text"
                            readOnly
                            className="react-autosuggest__input"
                            value={selectedLabel}
                            onClick={() => this.setState({ dropdownOpen: !dropdownOpen })}
                        />
                        {dropdownOpen && (
                            <div className="payeeCustomDropdown-menu">
                                {suppliersToShow.map((supplier) => {
                                    const isSelected = supplier.supplierId === currentPayee;
                                    return (
                                        <div
                                            key={supplier.supplierId}
                                            className={`payeeCustomDropdown-item${isSelected ? ' selected' : ''}`}
                                            // onMouseDown fires before blur — keeps dropdown open so supplier selection registers
                                            onMouseDown={(e) => {
                                                e.preventDefault(); // prevents input losing focus which would close the dropdown before selection
                                                this.setState({ dropdownOpen: false });
                                                this.handlePayeeChange({ target: { value: supplier.supplierId } });
                                            }}
                                        >
                                            <div className="suggestionItemUHG">
                                                <span className="supSugName">{supplier.supplierName}</span>
                                                <span className="supSugId">{supplier.vendorId}</span>
                                            </div>
                                        </div>
                                    );
                                })}
                                {showToggle && (
                                    <div
                                        className="payeeCustomDropdown-toggle-more"
                                        // onMouseDown with preventDefault keeps the dropdown open when Show more/less is clicked
                                        onMouseDown={(e) => {
                                            e.preventDefault(); // without this, dropdown closes before the list expands/collapses
                                            this.setState({ showAllSuppliers: !showAllSuppliers });
                                        }}
                                    >
                                        {showAllSuppliers
                                            ? <><FontAwesomeIcon icon={faChevronUp} size="xs" /> Show less</>
                                            : <><FontAwesomeIcon icon={faChevronDown} size="xs" /> Show more ({sortedSuppliers.length - MAX_SUPPLIERS} suppliers)</>}
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                );
            }
            else if (currentPayee !== undefined) {
                const display = this.renderSupplierSuggestion(currentSupplier[0]);
                return (<div >{display}</div>);
            }
            else {
                return (<div>No Supplier</div>);
            }
        }
    }

    render() {
        const { isAuthenticated, isLoading } = this.props;
        const display = (isAuthenticated === true && isLoading === false) ? this.getPayeeDisplay() : <p>No Payee</p>;
        return (
            <>
                {display}
            </>
        );
    }
}

export default PayeeSelection